import { useRef, useState } from "react";
import { toast } from "sonner";
import { api, fmtErr } from "../api";
import { Button, Card, CardContent, Label, Textarea } from "../components/ui";
import { PlayCircle, Volume2 } from "lucide-react";

export default function Manual() {
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [lastAudioUrl, setLastAudioUrl] = useState(null);
  const audioRef = useRef(null);

  const submit = async (playNow) => {
    if (!message.trim()) return;
    setBusy(true);
    try {
      const r = await api.post("/announcements/manual", { message, play_now: playNow });
      // Backend now returns audio_url as "/api/audio/tts/HASH.mp3" (public path).
      const raw = r.data.audio_url || "";
      const abs = raw.startsWith("http") ? raw : `${window.location.origin}${raw}`;
      setLastAudioUrl(abs);
      toast.success(playNow ? "Chamada enviada ao agente Windows" : "Áudio gerado");
      // auto-play in browser so the operator can hear it locally
      setTimeout(() => {
        if (audioRef.current) {
          audioRef.current.src = abs;
          audioRef.current.play().catch(() => {});
        }
      }, 100);
    } catch (e) { toast.error(fmtErr(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-2xl">
      <h1 className="font-display text-4xl uppercase leading-none mb-6">Chamada Manual</h1>
      <Card>
        <CardContent className="p-6 space-y-4">
          <div>
            <Label>Mensagem</Label>
            <Textarea
              data-testid="manual-message"
              rows={4}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Atenção, pilotos da categoria adulto..."
            />
            <div className="text-[10px] text-gray-500 uppercase tracking-widest mt-1">{message.length}/1000</div>
          </div>
          <div className="flex gap-2">
            <Button data-testid="manual-generate" variant="outline" onClick={() => submit(false)} disabled={busy || !message.trim()}>
              Gerar áudio
            </Button>
            <Button data-testid="manual-play" onClick={() => submit(true)} disabled={busy || !message.trim()}>
              <PlayCircle size={14} className="mr-1" /> Reproduzir na caixa
            </Button>
          </div>

          {lastAudioUrl && (
            <div className="border border-panel p-4 space-y-2 bg-black/30">
              <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-[hsl(var(--primary))]">
                <Volume2 size={14} /> Preview no navegador
              </div>
              <audio ref={audioRef} controls src={lastAudioUrl} className="w-full" data-testid="manual-preview-player" />
              <div className="text-xs text-gray-500">
                Este player é apenas para você conferir o áudio aqui no dashboard. A reprodução real acontece na <strong>caixa de som</strong> conectada ao PC Windows com o agente instalado.
              </div>
            </div>
          )}

          <div className="text-xs text-gray-500 border-t border-panel pt-4">
            <strong>Como funciona:</strong> ao clicar em <em>Reproduzir na caixa</em>, o áudio é gerado pelo TTS, enviado via WebSocket ao agente Windows e reproduzido na caixa de som física. O player acima é só um preview local para você conferir a voz.
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

